<template>
    <lyTable @tr="rowData" height="200" :columns="columns" :data="tableData">

    </lyTable>
</template>
<script>
export default {
    props: ['tableData'],
    data() {
        return {
            columns: [
                {
                    type: "index",
                    width: 70,
                    align: "center",
                },
                {
                    title: "gps时间",
                    key: "gpsTime1",
                }, {
                    title: "地址",
                    key: "address",
                },
                {
                    title: "速度",
                    key: "speed",
                },
               
            ],
            //tableData: [],

        };
    },
    methods: {
        rowData(row) {
            console.log(row);
            this.$emit('row', row)
        }
    },
    mounted() {

    },
};
</script>


// WEBPACK FOOTER //
// src/components/video/tlist.vue